import { createContext, useContext } from "react";
import type { AutoSignInStatus } from "pymble-ui/components";

export const AutoSignInStatusContext =
  createContext<AutoSignInStatus>("skipped");

export function useAutoSignInStatus(): AutoSignInStatus {
  return useContext(AutoSignInStatusContext);
}
